import { forwardRef } from 'react';
import { StyledInputTextArea } from './InputTextArea.styled';

export type InputTextAreaProps = Omit<
  React.HTMLProps<HTMLTextAreaElement>,
  'onChange'
> & {
  id?: string;
  sizes?: string;
  variant?: string;
  onChange?: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
};

const InputTextArea = forwardRef(
  (
    { id, sizes, variant, ...other }: InputTextAreaProps,
    ref: React.ForwardedRef<HTMLTextAreaElement>
  ) => (
    // @ts-expect-error we know
    <StyledInputTextArea
      aria-label={id}
      sizes={sizes}
      variant={variant}
      {...other}
      ref={ref}
    />
  )
);

InputTextArea.displayName = 'InputTextArea';

export default InputTextArea;
